/**
 * Helper para SEO Programático e Resolução de Horários Pré-Configurados
 * Suporta detecção de padrões como:
 * - /set-alarm-for-6-am
 * - /set-alarm-for-7-30-am
 * - /set-alarm-for-9-55-am
 * - /set-alarm-for/6-am
 * - /alarm-for-11-am
 * - /set-alarm-for-12-pm
 */

export const POPULAR_ALARM_TIMES = [
    { slug: '5-am', hour: 5, minute: 0, ampm: 'am', label: '05:00 AM' },
    { slug: '5-30-am', hour: 5, minute: 30, ampm: 'am', label: '05:30 AM' },
    { slug: '6-am', hour: 6, minute: 0, ampm: 'am', label: '06:00 AM' },
    { slug: '6-30-am', hour: 6, minute: 30, ampm: 'am', label: '06:30 AM' },
    { slug: '7-am', hour: 7, minute: 0, ampm: 'am', label: '07:00 AM' },
    { slug: '7-30-am', hour: 7, minute: 30, ampm: 'am', label: '07:30 AM' },
    { slug: '8-am', hour: 8, minute: 0, ampm: 'am', label: '08:00 AM' },
    { slug: '8-30-am', hour: 8, minute: 30, ampm: 'am', label: '08:30 AM' },
    { slug: '9-am', hour: 9, minute: 0, ampm: 'am', label: '09:00 AM' },
    { slug: '9-30-am', hour: 9, minute: 30, ampm: 'am', label: '09:30 AM' },
    { slug: '9-55-am', hour: 9, minute: 55, ampm: 'am', label: '09:55 AM' },
    { slug: '10-am', hour: 10, minute: 0, ampm: 'am', label: '10:00 AM' },
    { slug: '10-30-am', hour: 10, minute: 30, ampm: 'am', label: '10:30 AM' },
    { slug: '11-am', hour: 11, minute: 0, ampm: 'am', label: '11:00 AM' },
    { slug: '12-pm', hour: 12, minute: 0, ampm: 'pm', label: '12:00 PM' },
    { slug: '1-pm', hour: 1, minute: 0, ampm: 'pm', label: '01:00 PM' },
    { slug: '2-pm', hour: 2, minute: 0, ampm: 'pm', label: '02:00 PM' },
    { slug: '3-pm', hour: 3, minute: 0, ampm: 'pm', label: '03:00 PM' },
    { slug: '4-pm', hour: 4, minute: 0, ampm: 'pm', label: '04:00 PM' },
    { slug: '5-pm', hour: 5, minute: 0, ampm: 'pm', label: '05:00 PM' },
    { slug: '6-pm', hour: 6, minute: 0, ampm: 'pm', label: '06:00 PM' },
    { slug: '7-pm', hour: 7, minute: 0, ampm: 'pm', label: '07:00 PM' },
    { slug: '8-pm', hour: 8, minute: 0, ampm: 'pm', label: '08:00 PM' },
    { slug: '9-pm', hour: 9, minute: 0, ampm: 'pm', label: '09:00 PM' },
    { slug: '10-pm', hour: 10, minute: 0, ampm: 'pm', label: '10:00 PM' },
    { slug: 'midnight', hour: 12, minute: 0, ampm: 'am', label: '12:00 AM' }
];

export function parseTimeFromUrl(pathname) {
    if (!pathname || typeof pathname !== 'string') return null;
    const lower = pathname.toLowerCase();

    // Caso especial: meia-noite
    if (lower.includes('midnight') || lower.includes('meia-noite')) {
        return {
            hours: '12',
            minutes: '00',
            ampm: 'am',
            display: '12:00 AM',
            slug: 'midnight'
        };
    }

    const regex = /(?:set-alarm-for-|set-alarm-for\/|alarm-for-|alarm-for\/)([0-9]{1,2})(?:[-:]([0-9]{1,2}))?[-_]?(am|pm)?/;
    const match = lower.match(regex);

    if (match) {
        let hour = parseInt(match[1], 10);
        let min = match[2] ? parseInt(match[2], 10) : 0;
        let ampm = match[3] ? match[3].toLowerCase() : null;

        if (isNaN(hour) || isNaN(min)) return null;
        if (min < 0 || min > 59) min = 0;

        // Se AM/PM não for explicitado, inferir inteligentemente
        if (!ampm) {
            if (hour >= 1 && hour <= 11) {
                ampm = 'am';
            } else if (hour === 12) {
                ampm = 'pm';
            } else if (hour >= 13 && hour <= 23) {
                hour -= 12;
                ampm = 'pm';
            } else if (hour === 0 || hour === 24) {
                hour = 12;
                ampm = 'am';
            } else {
                ampm = 'am';
            }
        }

        if (hour < 1) hour = 12;
        if (hour > 12) hour = hour % 12 || 12;

        const hourStr = hour < 10 ? `0${hour}` : `${hour}`;
        const minStr = min < 10 ? `0${min}` : `${min}`;
        const timeDisplay = `${hourStr}:${minStr} ${ampm.toUpperCase()}`;

        return {
            hours: hourStr,
            minutes: minStr,
            ampm: ampm,
            display: timeDisplay,
            slug: `${hour}-${min ? min + '-' : ''}${ampm}`
        };
    }

    return null;
}
